export const INITIAL_STATS: any = {
  "collections": 6,
  "documents": 737,
  "graphs": 0,
  "completed": 647,
  "pending": 0,
  "processing": 0,
  "failed": 90
};

export const INITIAL_COLLECTIONS: any[] = [
  {
    "id": "9ed067e056d34183b0fac2611943cfe6",
    "title": "동북아역사재단 기타 간행도서 PDF",
    "description": "동북아역사재단 기타 게시판(2372)과 동북아역사자료센터에서 확인한 공식 PDF 자료입니다.",
    "tags": [
      "기타",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 59,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 49,
    "available_count": 49,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 10,
    "cancelled_count": 0,
    "local_count": 59,
    "external_count": 0,
    "total_size": 4216622244,
    "total_docs": 59,
    "completed_docs": 49
  },
  {
    "id": "1df6aef4ed0147daaaaf9ed8dbded710",
    "title": "동북아역사재단 번역·외국어 도서 PDF",
    "description": "동북아역사재단 번역·외국어 도서 게시판(2370)과 동북아역사자료센터에서 확인한 공식 PDF 자료입니다.",
    "tags": [
      "번역·외국어 도서",
      "번역",
      "외국어",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 51,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 48,
    "available_count": 48,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 3,
    "cancelled_count": 0,
    "local_count": 51,
    "external_count": 0,
    "total_size": 1375991433,
    "total_docs": 51,
    "completed_docs": 48
  },
  {
    "id": "a58ef34d98904d7e91c94f71bb3792e6",
    "title": "동북아역사재단 국제관계사 간행도서 PDF",
    "description": "동북아역사재단 국제관계사 게시판(2459)과 동북아역사자료센터에서 확인한 공식 PDF 원문 자료입니다.",
    "tags": [
      "국제관계사",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 83,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 74,
    "available_count": 74,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 9,
    "cancelled_count": 0,
    "local_count": 83,
    "external_count": 0,
    "total_size": 2525089726,
    "total_docs": 83,
    "completed_docs": 74
  },
  {
    "id": "d4f9217339ec46398ca6ba35dcd063aa",
    "title": "동북아역사재단 독도·동해 표기 간행도서 PDF",
    "description": "동북아역사재단 공식 홈페이지 자료 > 간행도서 > 독도·동해 표기 게시판에서 다운로드 가능한 PDF 원문을 수집한 자료군입니다. 출처: https://www.nahf.or.kr/web/portal/bbs/2454/list",
    "tags": [
      "독도·동해 표기",
      "독도",
      "동해",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 50,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 44,
    "available_count": 44,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 6,
    "cancelled_count": 0,
    "local_count": 50,
    "external_count": 0,
    "total_size": 3165314024,
    "total_docs": 50,
    "completed_docs": 44
  },
  {
    "id": "8996b0530e264a718e07daacf2ed020a",
    "title": "동북아역사재단 한일관계사 간행도서 PDF",
    "description": "동북아역사재단 공식 홈페이지 자료 > 간행도서 > 한일관계사 게시판에서 다운로드 가능한 PDF 원문을 수집한 자료군입니다. 출처: https://www.nahf.or.kr/web/portal/bbs/2458/list",
    "tags": [
      "한일관계사",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 243,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 211,
    "available_count": 211,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 32,
    "cancelled_count": 0,
    "local_count": 243,
    "external_count": 0,
    "total_size": 13691011555,
    "total_docs": 243,
    "completed_docs": 211
  },
  {
    "id": "33572e6d27da468194de563559bd0fd0",
    "title": "동북아역사재단 한중관계사 간행도서 PDF",
    "description": "동북아역사재단 공식 홈페이지 자료 > 간행도서 > 한중관계사 게시판에서 다운로드 가능한 PDF 원문을 수집한 자료군입니다. 출처: https://www.nahf.or.kr/web/portal/bbs/2457/list",
    "tags": [
      "한중관계사",
      "간행도서",
      "동북아역사재단",
      "공식 PDF"
    ],
    "doc_count": 251,
    "graph_count": 0,
    "created_by": "djuvyyxiddqybxyncfydsgdmkswlzgya",
    "created": "2026-06-26",
    "updated": "2026-06-26",
    "completed_count": 221,
    "available_count": 221,
    "analysis_ready_count": 0,
    "processing_count": 0,
    "failed_count": 30,
    "cancelled_count": 0,
    "local_count": 251,
    "external_count": 0,
    "total_size": 23888408928,
    "total_docs": 251,
    "completed_docs": 221
  }
];
